
import { Button } from "@/components/ui/button";

interface EmailLoginFormProps {
  email: string;
  password: string;
  isSubmitting: boolean;
  isResetting: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onResetPassword: (e: React.FormEvent) => void;
}

export const EmailLoginForm = ({
  email,
  password,
  isSubmitting,
  isResetting,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onResetPassword,
}: EmailLoginFormProps) => {
  return (
    <form className="mt-8 space-y-6" onSubmit={onSubmit}>
      <div className="rounded-md shadow-sm space-y-4">
        <div>
          <label htmlFor="email" className="sr-only">
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
            placeholder="Email address"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
            placeholder="Password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <Button
          type="button"
          variant="link"
          className="text-sm text-primary hover:text-primary-light"
          onClick={onResetPassword}
          disabled={isResetting}
        >
          {isResetting ? 'Sending reset instructions...' : 'Forgot your password?'}
        </Button>
      </div>

      <div className="space-y-4">
        <Button
          type="submit"
          className="w-full"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Signing in...' : 'Sign in'}
        </Button>
        
        <p className="text-center text-sm text-gray-600">
          Don't have an account?{' '}
          <Button
            type="button"
            variant="link"
            className="text-primary hover:text-primary-dark"
            onClick={() => window.location.href = '/signup'}
          >
            Sign up
          </Button>
        </p>
      </div>
    </form>
  );
};
